import React, { useEffect, useState } from 'react';
import SystemDashboard from 'layouts/SystemDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import { getMessage, saveMessage, updateMessage } from './MessageService';
import { useNavigate, useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
//import { Checkbox, FormControlLabel } from '@mui/material';

//import MembershipList from '../Memberships/MembershipList';
// import SubscriptionList from '../Subscriptions/SubscriptionList';
//import GroupList from '../Groups/GroupList';
import MessageUserList from './MessageUserList';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const MessageDetail = (): JSX.Element => {
  //const { sectionid, itemid } = useParams();
  //   const { sectionid = '' } = useParams<{ sectionid: string }>();
  //   const { itemid = '' } = useParams<{ itemid: string }>();

  const [sender, setSender] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');

  const navigate = useNavigate();
  const { messageid } = useParams();

  function clearMessageDetailsForm() {
    setSender('');
    setSubject('');
    setMessage('');
    setStatus('');
  }

  const cancelSaveOrUpdateAccount = () => {
    clearMessageDetailsForm();
    navigate('/system/dashboard/messages');
  };

  function saveOrUpdateMessage(e) {
    e.preventDefault();

    const messageData = { sender, subject, message, status };

    if (messageid) {
      updateMessage(messageid, messageData)
        .then(() => {
          navigate('/system/dashboard/messages');
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    } else {
      saveMessage(messageData)
        .then(() => {
          navigate('/system/dashboard/messages');
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }

  useEffect(() => {
    if (messageid) {
      console.log('messageid exists: ', messageid);
      getMessage(messageid)
        .then((response) => {
          console.log(response.data);
          setSender(response.data.sender);
          setSubject(response.data.subject);
          setMessage(response.data.message);
          setStatus(response.data.status);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [messageid]);

  return (
    <Container>
      <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={'/system/dashboard/accounts'}
            >
              Messages
            </Link>
            <Typography color="text.primary">Message Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">Message Detail</Typography>
        </Box>
        {/* {loading && <p>Loading...</p>} */}

        <Box>
          <form>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Sender
                </Typography>
                <TextField
                  variant="outlined"
                  name={'sender'}
                  fullWidth
                  value={sender} // Use the 'sequence' state variable as the value
                  onChange={(event) => setSender(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Subject
                </Typography>
                <TextField
                  variant="outlined"
                  name={'subject'}
                  fullWidth
                  value={subject} // Use the 'name' state variable as the value
                  onChange={(event) => setSubject(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Message
                </Typography>
                <TextField
                  variant="outlined"
                  name={'message'}
                  fullWidth
                  value={message} // Use the 'name' state variable as the value
                  onChange={(event) => setMessage(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Status
                </Typography>
                <TextField
                  variant="outlined"
                  name={'status'}
                  fullWidth
                  value={status}
                  onChange={(event) => setStatus(event.target.value)}
                />
              </Grid>
              <Grid item container xs={12}>
                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ xs: 'stretched', sm: 'center' }}
                  justifyContent={'space-between'}
                  width={1}
                  //margin={'0 auto'}
                  marginBottom={4}
                >
                  {/* <Box marginBottom={{ xs: 1, sm: 0 }}>
                    <Typography variant={'subtitle2'}>
                      You may also consider to update your{' '}
                      <Link color={'primary'} href={'#'} underline={'none'}>
                        billing information.
                      </Link>
                    </Typography>
                  </Box> */}
                  {/* <Button size={'large'} variant={'contained'} type={'submit'}>
                    Save
                  </Button> */}
                  <Button onClick={cancelSaveOrUpdateAccount}>Cancel</Button>
                  <Button onClick={saveOrUpdateMessage}>Save</Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
        <Box>
          <MessageUserList />
        </Box>
      </SystemDashboard>
    </Container>
  );
};

export default MessageDetail;
